import { useState } from 'react';

type Row = { date: string; time: string; direction: string; department: string; caller_number: string; called_number: string; user_name: string; user_email: string; duration: string; cost: number | null };

export default function CdrRequest() {
  const [numbers, setNumbers] = useState('');
  const [users, setUsers] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [rows, setRows] = useState<Row[]>([]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [searched, setSearched] = useState(false);

  function qs() {
    const p: Record<string, string> = { limit: '20000' };
    if (numbers.trim()) p.numbers = numbers.trim();
    if (users.trim()) p.users = users.trim();
    if (from) p.from = from; if (to) p.to = to;
    return new URLSearchParams(p).toString();
  }
  async function run() {
    if (!numbers.trim() && !users.trim()) { setErr('Enter at least one number or person.'); return; }
    setBusy(true); setErr(null);
    try {
      const r = await fetch('/cdr/api/search?' + qs(), { credentials: 'include' });
      if (r.status === 401) { setErr('Sign in to the CDR portal to view.'); setRows([]); return; }
      if (!r.ok) { setErr('Search failed (' + r.status + ')'); setRows([]); return; }
      const j = await r.json(); setRows(j.results || []); setSearched(true);
    } catch (e: any) { setErr(e?.message ?? 'failed'); } finally { setBusy(false); }
  }
  async function exportCsv() {
    const r = await fetch('/cdr/api/export?' + qs(), { credentials: 'include' });
    if (!r.ok) { setErr('Export failed'); return; }
    const j = await r.json(); window.location.href = j.download;
  }
  const inp = 'px-2.5 py-1.5 rounded-md border border-tnh-border dark:border-tnh-border-dark bg-transparent text-xs';
  const money = (n: number | null) => (n == null ? '—' : '$' + Number(n).toFixed(2));
  return (
    <div className="space-y-3">
      <div className="text-sm text-gray-500">Records request — paste multiple numbers and/or user emails (one per line or comma‑separated); every matching call in the window is returned, ready to export for a PRA/legal request.</div>
      <div className="grid gap-2 lg:grid-cols-2">
        <div className="card p-3"><label className="text-[11px] text-gray-500">Numbers (any format)</label><textarea value={numbers} onChange={(e) => setNumbers(e.target.value)} rows={5} placeholder={"+1 702-213-1978\n3104588411\n213 640 3934"} className={inp + ' w-full font-mono mt-1'} /></div>
        <div className="card p-3"><label className="text-[11px] text-gray-500">People (email substrings)</label><textarea value={users} onChange={(e) => setUsers(e.target.value)} rows={5} placeholder={"johanna.rodriguez@santamonica.gov\nelaine.polachek"} className={inp + ' w-full mt-1'} /></div>
      </div>
      <div className="card p-3 flex flex-wrap gap-2 items-end">
        <div><label className="text-[11px] text-gray-500">From</label><input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className={inp + ' block'} /></div>
        <div><label className="text-[11px] text-gray-500">To</label><input type="date" value={to} onChange={(e) => setTo(e.target.value)} className={inp + ' block'} /></div>
        <button onClick={run} disabled={busy} className="px-3 py-1.5 rounded-md bg-tnh-accent text-white text-xs disabled:opacity-50">{busy ? 'Searching…' : 'Search'}</button>
        <button onClick={exportCsv} disabled={rows.length === 0} className="px-3 py-1.5 rounded-md bg-gray-100 dark:bg-gray-800 text-xs disabled:opacity-50">Export CSV</button>
        <span className="text-xs text-gray-500">{rows.length > 0 ? `${rows.length} matching call(s)` : ''}</span>
      </div>
      {err && <div className="card p-3 text-sm text-tnh-err">{err}</div>}
      <div className="card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs text-gray-500 uppercase tracking-wide"><tr className="border-b border-tnh-border dark:border-tnh-border-dark">
            <th className="text-left px-4 py-2">Date</th><th className="text-left px-4 py-2">Time</th><th className="text-left px-4 py-2">Direction</th><th className="text-left px-4 py-2">Dept</th><th className="text-left px-4 py-2">Caller</th><th className="text-left px-4 py-2">Called</th><th className="text-left px-4 py-2">User</th><th className="text-right px-4 py-2">Duration</th><th className="text-right px-4 py-2">Cost</th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={9} className="text-center text-gray-500 py-8">{searched ? 'No matching calls.' : 'Paste numbers/people and Search.'}</td></tr>}
            {rows.map((r, i) => (<tr key={i} className="border-b last:border-b-0 border-tnh-border/40 dark:border-tnh-border-dark/40">
              <td className="px-4 py-2 text-xs whitespace-nowrap">{r.date}</td><td className="px-4 py-2 text-xs whitespace-nowrap">{r.time}</td>
              <td className="px-4 py-2 text-xs"><span className={`pill ${r.direction === 'Inbound' ? 'pill-ok' : 'pill-warn'}`}>{r.direction}</span></td>
              <td className="px-4 py-2 text-xs">{r.department || '—'}</td>
              <td className="px-4 py-2 font-mono text-xs">{r.caller_number}</td><td className="px-4 py-2 font-mono text-xs">{r.called_number}</td>
              <td className="px-4 py-2 text-xs">{r.user_name || r.user_email}</td><td className="px-4 py-2 text-right text-xs">{r.duration}</td><td className="px-4 py-2 text-right text-xs">{money(r.cost)}</td>
            </tr>))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
